import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Invoice } from '../../../../../models/invoice/invoice.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'np-invoice-tracked-full-info-modal',
  styleUrls: ['./invoice-tracked-full-info-modal.component.scss'],
  templateUrl: './invoice-tracked-full-info-modal.component.html',
})
export class InvoiceTrackedFullInfoModalComponent {
  @Input() invoice: Invoice;
  @Input() invoiceFullData: any;
  payerNameTransations = {
    Sender: 'Відправник',
    Recipient: 'Отримувач',
    ThirdPerson: 'Третя особа',
  };
}
